import * as THREE from "three";

export default class Robot {
    constructor() {
        this.group = new THREE.Group();
        this.group.scale.setScalar(0.8);
        this.build();
    }

    build() {
        const matBlue = new THREE.MeshLambertMaterial({ color: 0x3d8fd6 });
        const matWhite = new THREE.MeshLambertMaterial({ color: 0xe8f3ff });
        const matDark = new THREE.MeshLambertMaterial({ color: 0x243140 });
        const matGlowC = new THREE.MeshLambertMaterial({
            color: 0x0a3a38,
            emissive: 0x3ff5d8,
        });
        const matGlowO = new THREE.MeshLambertMaterial({
            color: 0x4a1208,
            emissive: 0xff5a24,
        });

        const treadGeo = new THREE.BoxGeometry(0.2, 0.22, 0.9);
        const treadL = new THREE.Mesh(treadGeo, matDark);
        treadL.position.set(-0.3, 0.11, 0);
        const treadR = new THREE.Mesh(treadGeo, matDark);
        treadR.position.set(0.3, 0.11, 0);
        this.group.add(treadL, treadR);

        const chassis = new THREE.Mesh(
            new THREE.BoxGeometry(0.66, 0.34, 0.66),
            matBlue,
        );
        chassis.position.y = 0.38;
        this.group.add(chassis);

        const torso = new THREE.Mesh(
            new THREE.BoxGeometry(0.5, 0.42, 0.5),
            matWhite,
        );
        torso.position.y = 0.76;
        this.group.add(torso);

        const visor = new THREE.Mesh(
            new THREE.BoxGeometry(0.38, 0.11, 0.05),
            matGlowC,
        );
        visor.position.set(0, 0.83, 0.265);
        this.group.add(visor);

        const shoulderGeo = new THREE.BoxGeometry(0.08, 0.1, 0.3);
        const shoulderL = new THREE.Mesh(shoulderGeo, matBlue);
        shoulderL.position.set(-0.36, 0.62, 0);
        const shoulderR = new THREE.Mesh(shoulderGeo, matBlue);
        shoulderR.position.set(0.36, 0.62, 0);
        this.group.add(shoulderL, shoulderR);

        const antenna = new THREE.Mesh(
            new THREE.BoxGeometry(0.05, 0.26, 0.05),
            matBlue,
        );
        antenna.position.set(0.16, 1.1, 0);
        this.group.add(antenna);

        const antennaTip = new THREE.Mesh(
            new THREE.BoxGeometry(0.09, 0.09, 0.09),
            matGlowO,
        );
        antennaTip.position.set(0.16, 1.27, 0);
        this.group.add(antennaTip);

        const chestLamp = new THREE.Mesh(
            new THREE.BoxGeometry(0.12, 0.05, 0.03),
            matGlowO,
        );
        chestLamp.position.set(0, 0.66, 0.26);
        this.group.add(chestLamp);
    }

}
